export const navstate = state => state.navstate
export const personalcenter = state => state.personalcenter
export const userName = state => state.userName
export const avatar = state => state.avatar
